import {validateEmail} from 'js/es/validation'

$(function() {
	updateSelectAllOption();

	// open/close a single category
	$(".category .category-title-bar").click(function() {
		$(this).parent(".category").toggleClass("closed");
		$(this).parent(".category").toggleClass("open");
		$(this).siblings(".option-list").slideToggle();
	});

	// expand all categories
	$(".category-title-bar .links #expand-all").click(function(e) {
		e.preventDefault();
		$(this).parents("#newsletter-list, #alert-list").find(".category").removeClass("closed");
		$(this).parents("#newsletter-list, #alert-list").find(".category").addClass("open");
		$(this).parents("#newsletter-list, #alert-list").find(".category .option-list").slideDown();
	});

	// collapse all categories
	$(".category-title-bar .links #collapse-all").click(function(e) {
		e.preventDefault();
		$(this).parents("#newsletter-list, #alert-list").find(".category").addClass("closed");
		$(this).parents("#newsletter-list, #alert-list").find(".category").removeClass("open");
		$(this).parents("#newsletter-list, #alert-list").find(".category .option-list").slideUp();
	});

	$(".option-list .option .option-details .nl-name").click(function() {
		$(this).parent(".pub-title-info").parent(".option-details").siblings(".checkbox").trigger("click");
		// $(this).closest(".checkbox").trigger('click');
	});


	// Event listener for clicking a single NL checkbox or radio
	$(".option-list .option:not(.select-all) .checkbox, .option-list .option input").click(function() {
		const currentOption = $(this).closest(".option");
		currentOption.toggleClass("checked");
		const userId = $("#user-email").attr("data-userId");

		// if this is a radio input, uncheck other sibling radio option elements.
		if ($(this).hasClass("radio")) {
			currentOption.siblings().removeClass("checked");
			optDownTracking($(this));
		}

		// if checkbox is checked and no cookies exists, show form.
		if (currentOption.hasClass("checked") && !Cookies.get("SUBSCRIBERID") && !Cookies.get("GSUSER") && $("#user-email").text() === "") {
			// update the subscription form with title and pubId
			const nlName = $(this).siblings(".option-details").children(".pub-title-info").children(".nl-name").text() + " Newsletter";
			const pubId = $(this).parent().data("pubid");

			$("#newsletter-cta .newsletter-title").text(nlName);
			$("#newsletter-cta input[name=publicationIds]").val(pubId);

			showSubscribeForm(true);

		// if checkbox is checked and cookies DO exist, then we'll just subscribe the user to the newsletter.
		} else if (currentOption.hasClass("checked") && (Cookies.get("SUBSCRIBERID") || Cookies.get("GSUSER") || userId !== 0)) {
			pubSubscribe("", userId);

		// if the checkbox is unchecked, then we'll unsubscribe the user
		} else if (Cookies.get("SUBSCRIBERID") || Cookies.get("GSUSER") || userId !== 0) {
			pubUnsubscribe(userId);
		}
	});

	// Event listener for clicking the select/unselect all option
	$(".option-list .option.select-all .checkbox").click(function() {
		const currentOption = $(this).parent(".option");
		currentOption.toggleClass("checked");
		const categoryOptionList = $(this).parent(".option").parent(".option-list");
		const userId = $("#user-email").data("userId");

		// if select all is checked and no cookies exist, show form.
		if (currentOption.hasClass("checked") && !Cookies.get("SUBSCRIBERID") && !Cookies.get("GSUSER") && $("#user-email").text() === "") {
			// check all the checkboxes in this section
			categoryOptionList.children(".option").addClass("checked");
			currentOption.children(".option-details").text("Unselect All");

			// update the subscription form with title and pubIds
			const nlName = categoryOptionList.siblings(".category-title-bar").children(".title").text() + " Newsletters";
			const subscriptions = updateSubscriptions();
			const subscribedPubs = subscriptions.newsletterSubscriptions;

			$("#newsletter-cta .newsletter-title").text(nlName);
			$("#newsletter-cta input[name=publicationIds]").val(subscribedPubs);

			// this part of the newsletter-cta creates issues with subscribe all checkboxes.
			// we already have this text on the page so it's redundant.
			$("#newsletter-cta .description").hide();

			showSubscribeForm(true);

		// if subscribe all is checked and cookies DO exists, then lets just subscribe the user to all alerts in this section.
		} else if (currentOption.hasClass("checked") && (Cookies.get("SUBSCRIBERID") || Cookies.get("GSUSER") || userId !== 0)) {
			categoryOptionList.children(".option").addClass("checked");
			currentOption.children(".option-details").text("Unselect All");
			pubSubscribe("", userId);
		} else if (Cookies.get("SUBSCRIBERID") || Cookies.get("GSUSER") || userId !== 0) {
			// unchecking subscribe all.. lets unsubscribe and uncheck all options in section.
			categoryOptionList.children(".option").removeClass("checked");
			currentOption.children(".option-details").text("Select All");
			pubUnsubscribe(userId);
		}
	});

	$(".my-subscriptions .answer span").click(function(e) {
		const userId = $("#user-email").attr("data-userId");

		$(this).addClass("selected");
		$(this).siblings().removeClass("selected");

		if ($(this).parents("#actc").length) {
			if ($(this).hasClass("yes")) {
				toggleConsentAffiliateToContact(userId, 1);
			} else {
				toggleConsentAffiliateToContact(userId, 0);
			}
		} else if ($(this).hasClass("yes")) {
			pubSubscribe(userId);
		} else {
			pubUnsubscribe(userId);
		}
	});

	// We need to create the modal early here in order to set a custom click event on the overlay
	createSimpleModal("#newsletter-cta");

	// Event listener for closing the modals.
	$("#overlay, #newsletter-cta .close").click(function(e) {
		if ($("#newsletter-cta .slide-two").is(":visible")) {
			$("*").css({"cursor": "wait"});
			reloadPage();
		} else if (!Cookies.get("SUBSCRIBERID") && !Cookies.get("GSUSER") && $("#user-email").text() === "") {
			// we'll only uncheck all selections if we don't yet know the user.
			$(".option").removeClass("checked");
			$(".select-all .option-details").text("Select All");
		}
	});

	// Event listening for unsubscribe all link (dev only)
	$("#unsub-all").click(function(e) {
		e.preventDefault();
		const email = encodeURIComponent($("#user-email span").text());
		const userId = $("#user-email").data("userId");

		$.ajax({
			url: "/ajax/subscriptionSignUp",
			method: "POST",
			data: "email=" + email +
					"&pubIds=" +
					"&alertIds=" +
					"&unsub=unsub" +
					"&trackEvar5=" + s.pageName +
					"&notify=0&uid=" + userId,
			timeout: 20000,
		}).then(function( result ) {
			if (result.SUCCESS) {
				location.reload();
			} else {
				showErrorMessage();
			}
		}).catch(function(error) {
			showErrorMessage();
		});
	});

	// Event listener to check for any sign of the user being from canada, and if they are, show the casl check box.
	$("#subscribe-form #email, #subscribe-form #country").change(function() {
		if (isCanadianRegistrant()) {
			// Show the Promotional Email checkbox
			$("#casl-check").slideDown();
		} else {
			$("#casl-check").slideUp();
		}
	});

	// adding a validation method to jquery validate
	$.validator.addMethod("notEqual", function(value, element, param) {
		return this.optional(element) || value !== param;
	});

	$("#subscribe-form").validate({
		rules: {
			email: {
				required: true,
				email: true,
				notEqual: "demo@globalspec.com",
				pattern: /^(.)+(@)(.)+[.](.)+$/,
			},
			country: "required",
			subConsent: {
				required: {
					depends: function() {
						return isCanadianRegistrant();
					},
				},
			},
		},
		errorLabelContainer: ".validation-error-msg",
		wrapper: "li",
		errorClass: "validation-error",
		messages: {
			email: {
				required: "The 'Email Address' field cannot be empty.",
				email: "The 'Email Address' must be in a valid email format.",
				notEqual: "This email address is reserved, please use another.",
				pattern: "The 'Email Address' must be in a valid email format.",
			},
			country: "The 'Country' field needs a valid selection.",
			subConsent: "You must agree to receive commercial messages to continue.",
		},
	});

	// Only used on myglobalspec/subscriptions when user is logged out
	$(".my-subscriptions .subscribe-form").on("submit", function (e) {
		const email = $(".my-subscriptions #email").val()
		const valid = validateEmail(email)
		if (!valid) {
			if (email == '') {
				$(".my-subscriptions #error-message").text("Email address is required.")
			}
			else {
				$(".my-subscriptions #error-message").text("Please make sure the email is in valid format.")
			}
			$(".my-subscriptions #error-message").attr('hidden', false)
			e.preventDefault();
			return false;
		}
		return true;
	});
});

function initializeClickEvents() {
	// Event listener for closing the modals.
	$("div#overlay, #close-cta-prompt").click(function(e) {
		if ($("#newsletter-cta .slide-two").is(":visible")) {
			$("*").css({"cursor": "wait"});
			reloadPage();
		} else if (!Cookies.get("SUBSCRIBERID") && !Cookies.get("GSUSER") && $("#newsletter-cta #email-address").text() === "") {
			// we'll only uncheck all selections if we don't yet know the user.
			$(".option").removeClass("checked");
			$(".select-all .option-details").text("Select All");
		}

		$("#overlay").fadeOut();
		$("#newsletter-cta").fadeOut();
	});
}

function isCanadianRegistrant() {
	return $("#subscribe-form #country").val().toLowerCase() === "canada"
		|| $("#subscribe-form #email").val().toLowerCase().substr(-3) === ".ca";
}

// reload the page, and add the userid param so that we don't lose the subscriber email
function reloadPage() {
	let url = window.location.href;
	const uid = encodeURIComponent($("#subscribe-confirmation").data("userId"));

	const pattern = new RegExp("\\b(uid=).*?(&|$)");
	if (url.search(pattern) >= 0) {
		url = url.replace(pattern, "$1" + uid + "$2");
	} else {
		url = url.replace(/\?$/, "");
		url = url + (url.indexOf("?") > 0 ? "&" : "?") + "uid=" + uid;
	}

	window.location.href = url;
}

function showSubscribeForm(dropToken) {
	resetCtaState();
	showSimpleModal("#newsletter-cta");

	if (dropToken) {
		assertSignupSeenToken();
	}
}

function showConfirmation() {
	$(".option.checked .option-details .subs-flag").addClass("checked");
	assertConfirmSeenToken();
}

function pubUnsubscribe(userId) {
	pubSubscribe("unsub", userId);
}

function pubSubscribe(arg, userId) {
	const subscriptions = updateSubscriptions();

	// avoid touching alerts on the NL signup page.
	if ($("html").hasClass("newsletter-signup")) {
		subscriptions.alertSubscriptions = "not given";
	}

	const subscribedPubs = subscriptions.newsletterSubscriptions;
	const subscribedAlerts = subscriptions.alertSubscriptions;
	const displayedPublicationIds = subscriptions.displayedPublicationIds;
	const email = encodeURIComponent($("#user-email span").text());

	$.ajax({
		url: "/ajax/subscriptionSignUp",
		method: "POST",
		data: "email=" + email +
				"&pubIds=" + subscribedPubs +
				"&alertIds=" + subscribedAlerts +
				"&unsub=" + arg +
				"&trackEvar5=" + s.pageName +
				"&notify=0&uid=" + userId +
				"&displayedPublicationIds=" + displayedPublicationIds,
		timeout: 20000,
	}).then(function( result ) {
		if (result.SUCCESS) {
			$(".option.checked .option-details .subs-flag").addClass("checked");
			$(".option:not(.checked) .option-details .subs-flag").removeClass("checked");
			updateSelectAllOption();

			if (result.UNSUB) {
				assertUnsubscribedToken();
			} else {
				assertSubscribedToken();
			}
		} else {
			showErrorMessage();
		}
	}).catch(function(error) {
		showErrorMessage();
	});

	return false;
}

// eslint-disable-next-line no-unused-vars
function subscribeFormSubmit(form) {
	updateSubscriptions("form");

	assertSignupSubmitToken();

	if ($("#subscribe-form").valid()) {
		$("#email-confirm").text($("#subscribe-form #email").val());

		$.ajax({
			url: "/ajax/subscriptionSignUp",
			method: "POST",
			data: $(form).serialize() + "&trackEvar5=" + s.pageName + "&notify=0",
			timeout: 20000,
			dataType: "json",
			crossDomain: true,
		}).then(function( result ) {
			// If the user is new, record the reg token
			if ((typeof result.NEWUSER !== "undefined") && (result.NEWUSER)) {
				assertNewsletterRegToken();
			}

			if (result.SUCCESS) {
				showConfirmation(result["USERID"]);
				updateSelectAllOption();
				assertSubscribedToken();
				$("#newsletter-list .category .option.checked .option-details .subs-flag").addClass("checked");
			} else if (!result.SUCCESS && !result.NEWUSER) {
				$("#subscribe-form .validation-error-msg").html("<li><label>" + result.MESSAGE + "</label></li>").show();
			} else {
				showErrorMessage();
			}
		}).catch(function(error) {
			showErrorMessage();
		});
	}

	return false;
}

// Updated the text to reflect the number of alerts the user is signed up for
// Also updates the hidden form input with the selected alert Ids
function updateSubscriptions(type) {
	let numSubscriptions = 0;

	let newsletterSubscriptions = $("#nl-category-list .category .option:not(.select-all).checked").map(function() {
		numSubscriptions++;
		return $(this).data("pubid");
	}).get().join(",");

	const alertSubscriptions = $("#al-category-list .category .option:not(.select-all).checked").map(function() {
		numSubscriptions++;
		return $(this).data("pubid");
	}).get().join(",");

	const otherPublicationSubscriptions = $(".other-publications .option.checked").map(function() {
		numSubscriptions++;
		return $(this).data("pubid");
	}).get().join(",");

	const contactPreferenceSubscriptions = $(".other-publications .yesno.option:not(#actc) .yes.selected").map(function() {
		numSubscriptions++;
		return $(this).parent().parent().data("pubid");
	}).get().join(",");

	if (otherPublicationSubscriptions !== "") {
		newsletterSubscriptions += "," + otherPublicationSubscriptions;
	}

	if (contactPreferenceSubscriptions !== "") {
		newsletterSubscriptions += "," + contactPreferenceSubscriptions;
	}

	$("#user-subs-info .total-subs").text(numSubscriptions);

	if (numSubscriptions === 1) {
		$("#user-subs-info .email-word").text("Email");
	} else {
		$("#user-subs-info .email-word").text("Emails");
	}

	let displayedPublicationIds = "";
	$('#contact-preferences input').each(function() {
		displayedPublicationIds += $(this).val() + ",";
	});

	if (type === "form") {
		$("#nl-signup-form #pubIds").val(newsletterSubscriptions);
	} else {
		return {
			"newsletterSubscriptions": newsletterSubscriptions,
			"alertSubscriptions": alertSubscriptions,
			"displayedPublicationIds": displayedPublicationIds
		};
	}
}

// updates the subscribe all option to reflect if all options in that section are checked or not
// if all options are checked then we change it to Unsubscribe all.
function updateSelectAllOption() {
	$("#nl-category-list .category, #al-category-list .category").each(function() {
		// const section = $(this).attr("class");
		const numOptions = $(this).children(".option-list").children(".option:not(.select-all)").length;
		const numCheckedOptions = $(this).children(".option-list").children(".option.checked:not(.select-all)").length;


		// if the checked options are greater than zero lets show the count, otherwise we'll hide the count to illustrate zero subscriptions.
		if (numCheckedOptions > 0) {
			if ($("html").hasClass("responsive-content") && $("html").hasClass("phone")) {
				$(this).children(".category-title-bar").children(".subscribed").children(".hidden").show();
			}
			$(this).children(".category-title-bar").children(".subscribed").show();
			$(this).children(".category-title-bar").children(".subscribed").children(".num-subscribed").text(numCheckedOptions);
		} else {
			$(this).children(".category-title-bar").children(".subscribed").hide();
		}

		if (numOptions === numCheckedOptions) {
			$(this).children(".option-list").children(".option.checked").children(".option-details").children(".subs-flag").slideDown();
			$(this).children(".option-list").children(".option.select-all").children(".option-details").text("Unselect All");
			$(this).children(".option-list").children(".option.select-all").addClass("checked");
		} else {
			$(this).children(".option-list").children(".option.select-all").children(".option-details").text("Select All");
			$(this).children(".option-list").children(".option.select-all").removeClass("checked");
		}
	});
}

function toggleConsentAffiliateToContact(userId, consentAffiliateToContact) {
	$.ajax({
		url: "/ajax/myglobalspec/setAffiliateConsentToContact.cfm?uid=" + userId + "&consentAffiliateToContact=" + consentAffiliateToContact,
		method: "GET",
		timeout: 20000,
	}).then(function( result ) {
		if (!result.SUCCESS) {
			showErrorMessage();
		}
	}).catch(function(error) {
		showErrorMessage();
	});
}

$(function() {
	$.ajax({
		url: "/ajax/subscriptions/getUserSubscriptionData",
		method: "POST",
		timeout: 2000,
		dataType: "json"
	}).then(function( result ) {
		localStorage.setItem("initialSubscribedAlerts",result.SUBSCRIBEDALERTIDS);
		localStorage.setItem("initialSubscribedPublications", result.SUBSCRIBEDPUBLICATIONIDS);
	}).catch(function(error) {
		// do nothing
	});
});

window.onbeforeunload = function() {
	const initialAlerts = localStorage.getItem("initialSubscribedAlerts");
	const initialPublications = localStorage.getItem("initialSubscribedPublications");

	if (initialAlerts || initialPublications)  {
		$.ajax({
			url: "/ajax/subscriptions/getUserSubscriptionData",
			method: "POST",
			timeout: 2000,
			data: {
				initialPubs : initialPublications,
				initialAlerts : initialAlerts
			},
			dataType: "json",
			async: true
		}).then(function (result) {
			if (result.SUBSCRIBEDALERTIDS !== initialAlerts
				|| result.SUBSCRIBEDPUBLICATIONIDS !== initialPublications ) {
				trackOmniClick(window.s_account, result.EVENTS, {
					channel: s.channel,
					eVar1: s.eVar1,
					eVar5: s.pageName,
					eVar42: result.EVAR42,
					list1: result.LIST1
				}, 'Changes on mange subs page');

				return "data recorded";
			}
			return "no data to record";
		}).catch(function (error) {
			// do nothing
		});
	}
}

// handle omniture tracking for webinar / white paper opt down
// given a checked input jQuery object, it will give you the correct onclick event
// assumes that the label is the next sibling to the input - MRF 7/7/2020
function optDownTracking(checkedInput) {
	const labelText = checkedInput.next().text();

	if (labelText.length) {
		if (labelText.indexOf("month") > 0) {
			trackOmniClick(window.s_account, 'event64', {campaign: s.campaign, eVar22: s.campaign, prop22: s.campaign}, 'Opt Down to Monthly Submitted');
		} else if (labelText.indexOf("week") > 0) {
			trackOmniClick(window.s_account, 'event63', {campaign: s.campaign, eVar22: s.campaign, prop22: s.campaign}, 'Opt Down to Weekly Submitted');
		} else if (labelText.indexOf("ever") > 0) {
			trackOmniClick(window.s_account, 'event57', {campaign: s.campaign, eVar22: s.campaign, prop22: s.campaign}, 'Unsub Submitted');
		}
	}
}
